import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Help extends Component {
  static propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    iconColor: PropTypes.string
  };

  static defaultProps = {
    width: 22,
    height: undefined,
    iconColor: '#000'
  };

  render() {
    const { height, width, iconColor } = this.props;

    return (
      <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 27.2 27.2" height={height} width={width}>
        <path
          d="M13.6 16c-.5 0-.8-.3-.8-.8 0-1.4.6-2.9 1.9-3.8.6-.5.8-1.1.6-1.9-.2-.6-.6-1.3-1.4-1.4-.6-.2-1.1 0-1.6.3s-.6 1-.6 1.4c0 .5-.3.8-.8.8s-.8-.3-.8-.8c0-1.1.5-2.1 1.3-2.7.8-.6 1.9-1 2.9-.6 1.3.3 2.4 1.3 2.7 2.7.3 1.3-.2 2.6-1.3 3.5-.8.6-1.4 1.6-1.4 2.6.1.4-.2.7-.7.7zM13.6 20.8c-.2 0-.5-.2-.6-.3-.2-.2-.2-.3-.2-.5s0-.5.2-.6c.3-.3.8-.3 1.1 0 .2.2.3.3.3.6 0 .2-.2.5-.3.5 0 .1-.3.3-.5.3z"
          fill={iconColor}
        />
        <g>
          <path
            d="M13.6 27.2C6.1 27.2 0 21.1 0 13.6S6.1 0 13.6 0s13.6 6.1 13.6 13.6-6 13.6-13.6 13.6zm0-25.6c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12z"
            fill={iconColor}
          />
        </g>
      </svg>
    );
  }
}
